import { Reveal } from "react-awesome-reveal";

import stars from "../assets/images/png/5stars.png";

export const Testimonials = () => {
  return (
    <section id="Testimonials">
      <div style={{ backgroundColor: "#00AC5A" }}>
        <div
          className="container py-5 text-white"
          style={{ maxWidth: "800px" }}
        >
          <div className="text-center">
            <div className="h2 py-5 fw-bold">
              <span className="border-bottom border-info border-3">
                Testimonials.
              </span>
            </div>
            <p>お客様の声</p>
          </div>
          <div>
            <p className="text-md-center fw-light">
              クラウドソーシングサイト経由で依頼完了後のお客様からのレビューを一部掲載しております。
            </p>
            <Reveal triggerOnce right cascade>
              <div className="col border-top">
                <img src={stars} alt="5stars" width="100" />
                <div className="col-md-12">
                  <p>
                    Googleカレンダーを日毎にスプレッドシートに反映させ、
                    <br />
                    会社の日報を自動で作成できるようスクリプトを組んでいただきました。
                    <br />
                    別シートにかなり丁寧な説明書きも頂き、
                    <br />
                    もちろんスクリプトも問題なく動作し大満足の仕上がりです。
                    <br />
                    社内をGoogleアプリケーションで統一している最中ですので、
                    <br />
                    ぜひまた依頼させて頂こうと思います。ありがとうございました。
                  </p>
                </div>
                <div className="row align-items-center justify-content-between">
                  <div className="col">2020年10月1日</div>
                  <div className="col text-end">IT・通信・インターネット</div>
                </div>
              </div>
              <div className="col border-top">
                <img src={stars} alt="5stars" width="100" />
                <div className="col-md-12">
                  <p>
                    対応から修正まで素早い対応でありがとうございます。
                    <br />
                    また何かございましたらお願い致します。
                    <br />
                    ありがとうございました。
                  </p>
                </div>
                <div className="row align-items-center justify-content-between">
                  <div className="col">2020年12月25日</div>
                  <div className="col text-end">卸売・小売</div>
                </div>
              </div>
              <div className="col border-top">
                <img src={stars} alt="5stars" width="100" />
                <div className="col-md-12">
                  <p>
                    とても丁寧に対応してもらいました。
                    <br />
                    顧客の「思い」をくみ取る想像力と提案力に裏打ちされたいい仕事をしていただきました。
                    <br />
                    ありがとうございました。
                  </p>
                </div>
                <div className="row align-items-center justify-content-between">
                  <div className="col">2020年12月26日</div>
                  <div className="col text-end">スポーツ・フィットネス</div>
                </div>
              </div>
              <div className="col border-top">
                <img src={stars} alt="5stars" width="100" />{" "}
                <div className="col-md-12">
                  <p>
                    この度も誠にありがとうございました。
                    <br />
                    レスポンスが早く、想像通りのものを作成頂きありがとうございます。
                    <br />
                    今後ともよろしくお願いいたします。
                  </p>
                </div>
                <div className="row align-items-center justify-content-between">
                  <div className="col">2021年4月23日</div>
                  <div className="col text-end">卸売・小売</div>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
